import { UserOrg } from '../models/userOrg';

const GRID_COMMUNITY_ORG_ID = 'caec3234-15cd-43c6-beed-5436080693ba';

export type FilterUserOrgsResult = {
  orgs: UserOrg[];
};

function decorateOrgLogos(orgs: UserOrg[]): UserOrg[] {
  const apiUrl = window.getApiUrl();
  return orgs.map(org => ({
    ...org,
    logo: org.logo ? `${apiUrl}/v1/images/org/${org.logo}` : org.logo,
  }));
}

function hasGridCommunityAdminAccess(org: UserOrg): boolean {
  return org.memberRoles.some(role => role.permission.permissions.some(perm => perm.access !== 'View Only'));
}

export function filterUserOrgs(orgs: UserOrg[]): FilterUserOrgsResult {
  const filteredOrgs = decorateOrgLogos(orgs).filter(org => {
    if (org._id.id === GRID_COMMUNITY_ORG_ID) {
      return hasGridCommunityAdminAccess(org);
    }
    return true;
  });

  return {
    orgs: filteredOrgs,
  };
}
